import Class from './Class'

export default Class